export function Header() {
  return (
    <header className="app-header">
      <h1>ITRI 工具箱</h1>
      <span className="subtitle">純前端 · 零上傳</span>
    </header>
  );
}
